import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import config from '../../../config';

const DocumentModal = ({ isOpen, toggle, documentToShow, container = 'client-page' }) => {
  const { user } = useSelector((state) => state.user);
  const isRestricted =
    container === 'clearing-agent-page' ||
    user?.type === 'managenmnt_operator' ||
    user?.type === 'clearing_agent' ||
    user?.type === 'application_client' ||
    user?.type === 'application_corporate_client';

  useEffect(() => {
    if (isRestricted && isOpen) {
      const handleKeyDown = (e) => {
        // Block Ctrl+P (Print) and Ctrl+S (Save)
        if ((e.ctrlKey || e.metaKey) && (e.key === 'p' || e.key === 's' || e.key === 'P' || e.key === 'S')) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      window.addEventListener('keydown', handleKeyDown, true);
      return () => window.removeEventListener('keydown', handleKeyDown, true);
    }
  }, [isRestricted, isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} container={container} className="modal-xl">
      <div className="modal-header">
        <button type="button" className="close" onClick={toggle}>
          &times;
        </button>
      </div>
      <ModalBody style={{ padding: 0 }}>
        <div
          onContextMenu={isRestricted ? (e) => e.preventDefault() : undefined}
          style={
            isRestricted
              ? {
                  position: 'relative',
                  userSelect: 'none',
                  height: '80vh',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  background: '#525659', // PDF viewer dark background match
                }
              : { position: 'relative', height: '80vh' }
          }
        >
          {isRestricted && (
            <style>
              {`
                @media print {
                  body { display: none !important; }
                  .modal { display: none !important; }
                }
                /* Hide scrollbar for cleaner look if needed, or keep for UX */
                ::-webkit-scrollbar {
                    width: 8px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 4px;
                }
              `}
            </style>
          )}
          <iframe
            name="documentIframe"
            src={`${config.api.URL.replace('/api/v1', '')}/${documentToShow}#zoom=100${
              isRestricted ? '&toolbar=0&navpanes=0' : ''
            }`}
            width="100%"
            style={{
              height: isRestricted ? '5000px' : '80vh', // Large height to allow parent scrolling when interaction is disabled
              pointerEvents: isRestricted ? 'none' : 'auto',
              border: 'none',
            }}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DocumentModal;